<template>
  <div class="card-box">
    <el-button v-edit:customer="customer" class="pull-right" type="warning" size="mini" icon="el-icon-edit" circle></el-button>
    <h4 class="header-title m-t-0 m-b-20">Informations</h4>
    <ul class="ul-fa">
      <li>
        <i class="fa fa-id-card"></i>
        <customer :item="customer" present="name"></customer>
      </li>
      <li v-if="customer.job_type">
        <customer :item="customer" present="job"></customer>
      </li>
      <li>
        <customer :item="customer" present="city"></customer>
      </li>
      <li v-if="customer.contact_details.first_phone">
        <customer :item="customer" present="first_phone"></customer>
      </li>
      <li v-if="customer.contact_details.second_phone">
        <customer :item="customer" present="second_phone"></customer>
      </li>
      <li v-if="customer.contact_details.email">
        <div style="overflow: hidden;"><customer :item="customer" present="email"></customer></div>
      </li>
      <li v-if="customer.contact_details.website">
        <customer :item="customer" present="website"></customer>
      </li>
      <li>
        <customer :item="customer" present="remarks"></customer>
      </li>
    </ul>
  </div>
</template>

<script>
  import Customer from '../../../Entities/Customer.vue'

  export default {
    components: {Customer},
    name: 'customer-informations-summary-widget',
    props: ['customer']
  }
</script>



// WEBPACK FOOTER //
// CustomerInformationsSummaryWidget.vue?1b48f8d5